export default __webpack_public_path__ + "static/media/spartan.d5a4e152.png";